import { FormProvider } from 'react-hook-form';
import { useEditClientAdminUserModal } from './hooks';
import { EditClientAdminUserModalPresentation } from './presentations';

type Props = {
  userId: number;
  name: string;
  email: string;
  onClose: () => void;
};

export const EditClientAdminUserModal: React.FC<Props> = ({ userId, name, email, onClose }) => {
  const {
    state: { methods },
    actions: { handleSubmit },
  } = useEditClientAdminUserModal({ userId, name, email });

  return (
    <FormProvider {...methods}>
      <EditClientAdminUserModalPresentation onClose={onClose} onConfirm={handleSubmit} />
    </FormProvider>
  );
};
